"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PlayerStatus_1 = require("../../types/PlayerStatus");
const getTimeString_1 = require("../../utils/getTimeString");
const Component_1 = __importDefault(require("../Component"));
const renderSvgSprite_1 = require("../../render/renderSvgSprite");
const spinner_png_1 = __importDefault(require("../../resources/img/spinner.png"));
const player_play_sprite_svg_1 = __importDefault(require("../../resources/svg/player-play.sprite.svg"));
const stop_sprite_svg_1 = __importDefault(require("../../resources/svg/stop.sprite.svg"));
const heart_sprite_svg_1 = __importDefault(require("../../resources/svg/heart.sprite.svg"));
const shuffle_sprite_svg_1 = __importDefault(require("../../resources/svg/shuffle.sprite.svg"));
const skip_back_sprite_svg_1 = __importDefault(require("../../resources/svg/skip-back.sprite.svg"));
const repeat_sprite_svg_1 = __importDefault(require("../../resources/svg/repeat.sprite.svg"));
const volume_sprite_svg_1 = __importDefault(require("../../resources/svg/volume.sprite.svg"));
const isTrackLiked_1 = require("../../utils/tracks/isTrackLiked");
class PlayerComponent extends Component_1.default {
    constructor(trackData, status, shuffle, repeat, isLoading) {
        super();
        this.trackData = trackData;
        this.status = status;
        this.shuffle = shuffle;
        this.repeat = repeat;
        this.isLoading = isLoading;
    }
    getTemplate() {
        const centerButtonTemplate = this.getCenterButtonTemplate(this.status);
        const isLiked = (0, isTrackLiked_1.isTrackLiked)(this.trackData);
        const songInfoContent = this.isLoading
            ? `
      <div class="player__track-name flex">
        <div class="loading loading_small player-loading">
          <img class="loading__spinner" src="${spinner_png_1.default}" alt="Идёт загрузка">
        </div>
      </div>
    `
            : `
      <div class="player__track-name flex">
        <img class="player__track__img" src="${this.trackData.image}" alt="${this.trackData.name} - ${this.trackData.artist.name}">
        <div class="player__track-name__content">
          <div class="flex player__name__header">
            <h3 class="player__track__h3">${this.trackData.name}</h3>
            <button class="player__track__like ${isLiked ? 'player__track__like_active' : ''}" id="player-like">
              ${(0, renderSvgSprite_1.renderSvgSprite)(heart_sprite_svg_1.default.url, 'player__track__like-svg')}
            </button>
          </div>
          <p class="player__track__author">${this.trackData.artist.name}</p>
        </div>
      </div>
    `;
        return `
      <footer class="footer">
        <div class="player flex">
          ${songInfoContent}
          <div class="player__controls">
            <div class="player__controls__header">
              <button class="player__shuffle-btn" id="player-shuffle">
                ${(0, renderSvgSprite_1.renderSvgSprite)(shuffle_sprite_svg_1.default.url, 'player__shuffle-svg player__svg ' + (this.shuffle ? 'player__svg_active' : ''))}
              </button>
              <button class="player__skipback-btn player__command-btn" id="player-previous">
                ${(0, renderSvgSprite_1.renderSvgSprite)(skip_back_sprite_svg_1.default.url, 'player__skipback-svg')}
              </button>
                ${centerButtonTemplate}
              <button class="player__skipnext-btn player__command-btn" id="player-next">
                ${(0, renderSvgSprite_1.renderSvgSprite)(skip_back_sprite_svg_1.default.url, 'player__skipnext-svg')}
              </button>
              <button class="player__repeat-btn" id="player-repeat">
                ${(0, renderSvgSprite_1.renderSvgSprite)(repeat_sprite_svg_1.default.url, 'player__repeat-svg player__svg ' + (this.repeat ? 'player__svg_active' : ''))}
              </button>
            </div>
            <div class="player__controls__footer"> <span class="player__time-start" id="player-time">0:00</span>
              <div class="player__range-play" id="range-play"></div><span class="player__time-end">${(0, getTimeString_1.getTimeString)(this.trackData.duration)}</span>
            </div>
          </div>
          <div class="player__volume">
            ${(0, renderSvgSprite_1.renderSvgSprite)(volume_sprite_svg_1.default.url, 'player__volume-svg')}
            <div class="player__volume-range" id="range-volume"></div>
          </div>
        </div>
      </footer>
    `;
    }
    addOnPlayListener(callback) {
        const playButton = document.getElementById('player-play');
        if (playButton) {
            playButton.addEventListener('click', callback);
        }
    }
    addOnStopListener(callback) {
        const stopButton = document.getElementById('player-stop');
        if (stopButton) {
            stopButton.addEventListener('click', callback);
        }
    }
    addOnNextListener(callback) {
        const nextButton = document.getElementById('player-next');
        if (!nextButton) {
            throw new Error('Button with id: player-next is not found');
        }
        nextButton.addEventListener('click', callback);
    }
    addOnPreviousListener(callback) {
        const previousButton = document.getElementById('player-previous');
        if (!previousButton) {
            throw new Error('Button with id: player-previous is not found');
        }
        previousButton.addEventListener('click', callback);
    }
    addOnShuffleListener(callback) {
        const shuffleButton = document.getElementById('player-shuffle');
        if (!shuffleButton) {
            throw new Error('Button with id: player-shuffle is not found');
        }
        shuffleButton.addEventListener('click', callback);
    }
    addOnRepeatListener(callback) {
        const repeatButton = document.getElementById('player-repeat');
        if (!repeatButton) {
            throw new Error('Button with id: player-repeat is not found');
        }
        repeatButton.addEventListener('click', callback);
    }
    addOnLikeListener(callback) {
        const likeButton = document.getElementById('player-like');
        if (likeButton) {
            likeButton.addEventListener('click', callback);
        }
    }
    getCenterButtonTemplate(status) {
        return status === PlayerStatus_1.PlayerStatus.Stopped
            ? `
      <button class="player__play-btn player__command-btn" id="player-play">
        ${(0, renderSvgSprite_1.renderSvgSprite)(player_play_sprite_svg_1.default.url, 'player__play-svg')}
      </button>
    `
            : `
      <button class="player__play-btn player__command-btn" id="player-stop">
        ${(0, renderSvgSprite_1.renderSvgSprite)(stop_sprite_svg_1.default.url, 'player__play-svg')}
      </button>
      `;
    }
}
exports.default = PlayerComponent;
